export default __webpack_public_path__ + "static/media/aavhan.9c813cb6.png";